import { Node, mergeAttributes } from '@tiptap/core';

export interface TaskLinkAttrs {
  id: number;
  title?: string;
  label?: string;
  completed?: boolean;
  listColor?: string;
  listId?: number;
  listName?: string;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    taskLink: {
      insertTaskLink: (attrs: TaskLinkAttrs) => ReturnType;
    };
  }
}

export const TaskLink = Node.create({
  name: 'taskLink',
  inline: true,
  group: 'inline',
  atom: true,

  addAttributes() {
    return {
      id: { default: null },
  title: { default: null },
  label: { default: null },
  completed: { default: false },
  listColor: { default: null },
  listId: { default: null },
  listName: { default: null },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-task-link="1"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const { id, title, label, completed, listColor, listId, listName } = HTMLAttributes as any;
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-task-link': '1',
        'data-task-id': id,
        'data-task-completed': completed ? '1' : '0',
        'data-list-id': listId ?? undefined,
        'data-list-name': listName ?? undefined,
        class: 'task-chip',
        title: title || 'Open task',
        contenteditable: 'false',
        style: listColor ? `--chip-color: ${listColor}` : undefined,
      }),
      label || title || '',
    ];
  },

  addCommands() {
    return {
      insertTaskLink:
        (attrs: TaskLinkAttrs) => ({ commands }) => {
          return commands.insertContent({ type: this.name, attrs });
        },
    };
  },
});

export default TaskLink;
